let language = {
    FORGET_PWD_RESET_TITLE: "重置密码",
    FORGET_PWD_SEND_RESET_LINK_TEXT: "请输入您的电子邮件地址，我们需要几分钟的时间向您发送密码重置链接",

    FORGET_PWD_FORM_EMAIL_LABEL: "电子邮箱:",
    FORGET_PWD_FORM_EMAIL_PLACEHOLDER: "sample@email.com",
    FORGET_PWD_FORM_EMAIL_ERROR_TIP1: "请输入正确的电子邮箱地址",
    FORGET_PWD_FORM_SEND_BTN: "发送重置电子邮箱",

    FORGET_PWD_FORM_SIGNIN_TEXT: "登录",
    FORGET_PWD_FORM_SIGNUP_TEXT: "注册",

    FORGET_PWD_HAS_SEND_TEXT1: "请输入正确的电子邮件地址",
    FORGET_PWD_HAS_SEND_TEXT2: "点击邮件中的链接重置密码。如果你没有看到这封邮件，检查你的“垃圾邮件文件夹”",
    FORGET_PWD_RESEND_TEXT: "我没有收到邮件",
};

export { language }